import type { PixelEvent } from "../types";

export interface QueueOptions {
  flushSize: number;
  flushIntervalMs: number;
  onFlush: (events: PixelEvent[], reason: FlushReason) => void;
}

export type FlushReason = "size" | "interval" | "visibility" | "manual";

export class EventQueue {
  private buffer: PixelEvent[] = [];
  private timer: ReturnType<typeof setTimeout> | null = null;
  private readonly opts: QueueOptions;

  constructor(opts: QueueOptions) {
    this.opts = opts;
  }

  enqueue(event: PixelEvent): void {
    this.buffer.push(event);
    if (this.buffer.length >= this.opts.flushSize) {
      this.flush("size");
    } else if (this.timer === null) {
      this.scheduleFlush();
    }
  }

  flush(reason: FlushReason): void {
    if (this.timer !== null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.buffer.length === 0) return;
    const batch = this.buffer;
    this.buffer = [];
    this.opts.onFlush(batch, reason);
  }

  private scheduleFlush(): void {
    this.timer = setTimeout(() => {
      this.timer = null;
      this.flush("interval");
    }, this.opts.flushIntervalMs);
  }
}
